'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = exports.initAutoDiscountCode = exports.captureTalkable = exports.resetDiscount = exports.resetDiscountUI = exports.updateDiscountUI = exports.checkCartGifts = exports.updateGiftMeta = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _AddToCart = require('scripts/components/AddToCart');

var _Helpers = require('scripts/components/Helpers');

var _LineItem = require('scripts/components/LineItem');

var _LazyLoader = require('scripts/components/LazyLoader');

var _Cart = require('scripts/modules/Cart');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BTN_TRANSITION_DURATION = 300;

// Updated 10/26/2020 for the 2020 holiday season

// Modules

// Components
var TIERS = {
  HOLIDAY25: 3000,
  HOLIDAY30: 6000
};

var dom = {
  body: 'body',
  bodyWithOpenCodeForm: 'body.code-form-open',
  codeContainer: '[cart-code-container]',
  codeForm: '[cart-code-form]',
  codeToggle: '[cart-code-toggle]',
  codeInput: '[cart-code-input]',
  codeSubmit: '[cart-code-submit]',
  codeRemove: '[cart-code-remove]',
  giftSelect: '[cart-code-select="gift"]',
  giftSelectNative: '[free-gift-select]',
  giftSelectItem: '[cart-code-select-item]',
  dropdownContainer: '[data-dropdown]',
  dropdownValue: '[data-dropdown-value]',
  noForm: 'noform',
  cartContainer: '[cart-container]',
  cartSubtotal: '[cart-subtotal]',
  cartExtraTotals: '[cart-code-totals]',
  cartFullInfo: '[cart-full-info]',
  lineItem: '[line-item]'
};

var codeSubmitError = function codeSubmitError(state) {
  $(dom.codeSubmit).removeClass('is-loading').addClass('is-error');
  setTimeout(function () {
    $(dom.codeSubmit).removeClass('is-error');
  }, BTN_TRANSITION_DURATION + 1000);
};

var codeSubmitSuccess = function codeSubmitSuccess(state) {
  $(dom.body).removeClass('code-form-open');
  $(dom.codeSubmit).removeClass('is-loading').addClass('is-success');
  setTimeout(function () {
    $(dom.codeSubmit).removeClass('is-success');
    $(dom.codeInput).val('');
    $(dom.codeToggle).removeClass('is-hidden');
    $(dom.codeContainer).addClass('is-hidden').removeClass('is-active');
    $(dom.codeForm).removeClass('is-active');
    (0, _Cart.updateCartUI)();
  }, BTN_TRANSITION_DURATION);
};

var codeSubmitInvalid = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(err, $form) {
    var codeType, options, transition;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            codeType = $form ? $form.attr('cart-code-form') : false;
            options = _jsCookie2.default.getJSON('bva-cart-coupon-code-options') || { skip_errors: false };


            $(dom.codeSubmit, $form).removeClass('is-loading').addClass('is-error');

            // Display passive error text in cart rather than show an alert
            if (options.skip_errors) {
              $(dom.cartFullInfo).html(err);
            }

            transition = BTN_TRANSITION_DURATION;

            if (options.skip_errors) {
              _context.next = 10;
              break;
            }

            _context.next = 8;
            return resetDiscount();

          case 8:
            setTimeout(function () {
              if (codeType == 'gift' && window.bva.cart.item_count == 0) {
                alert('You must have at least 1 item in cart to redeem a free gift.');
              } else if (err) {
                alert(err);
              } else {
                alert('Code entered is not valid.');
              }
            }, BTN_TRANSITION_DURATION);
            transition = BTN_TRANSITION_DURATION + 1000;

          case 10:

            setTimeout(function () {
              $(dom.codeSubmit, $form).removeClass('is-error');
            }, transition);

          case 11:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function codeSubmitInvalid(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var updateGiftMeta = exports.updateGiftMeta = function updateGiftMeta($giftLineItem) {
  var $image = $giftLineItem.find('[data-item-image]');
  var $title = $giftLineItem.find('[data-item-title]');
  var $selected = $giftLineItem.find('[data-dropdown-value].is-active');
  var imageUrl = $selected.attr('data-image');
  var imageUrl2x = $selected.attr('data-image2x');
  var imageAlt = $selected.attr('data-image-alt');
  var title = $giftLineItem.find(dom.giftSelect).val();
  $image.removeAttr('data-was-processed').attr('data-src', imageUrl).attr('data-srcset', imageUrl2x).attr('src', imageUrl).attr('srcset', imageUrl2x).attr('alt', imageAlt);
  $title.text(title);
  (0, _LazyLoader.update)();
};

var giftSwap = function giftSwap(oldVariantId, newVariantId) {
  var _lineItemQtyMap;

  var lineItemQtyMap = (_lineItemQtyMap = {}, (0, _defineProperty3.default)(_lineItemQtyMap, oldVariantId, 0), (0, _defineProperty3.default)(_lineItemQtyMap, newVariantId, 1), _lineItemQtyMap);

  (0, _AddToCart.cartUpdate)(lineItemQtyMap);
};

var checkCartGifts = exports.checkCartGifts = function checkCartGifts(cart) {
  // All needed updates passed to and handled in AddToCart/updateCart
  var giftLineKey = void 0;
  var giftId = void 0;
  var numGiftLineItems = 0;
  var lineNumber = false;
  var numGifts = cart.items.reduce(function (total, item, index) {
    if (Object.keys(window.bva.giftProducts).includes(item.product_id.toString())) {
      total += item.quantity;
      giftId = item.id;
      giftLineKey = item.key;
      numGiftLineItems++;
      lineNumber = index + 1;
    }
    return total;
  }, 0);
  var numRegItems = cart.item_count - numGifts;
  if (numRegItems > 0 && numGifts > 1) {
    // Remove extra gifts (only 1 allowed)
    // Safegaurd against people adding free items via console
    if (numGiftLineItems == 1) {
      return (0, _defineProperty3.default)({}, giftLineKey, 1);
    } else {
      return (0, _defineProperty3.default)({}, giftLineKey, 0);
    }
  } else if (numRegItems == 0 && numGifts > 0) {
    // Remove gifts
    var skipCartAction = true;
    removeCouponCode(skipCartAction);
    return (0, _defineProperty3.default)({}, giftLineKey, 0);
  } else {
    // Toggle gift form
    if (numGifts > 0 || window.chCouponCode && window.chCouponCode != '') {
      $(dom.codeForm).removeClass('is-active');
      $(dom.codeContainer).addClass('is-hidden').removeClass('is-active');
    } else {
      $(dom.codeForm).removeClass('is-active');
      $(dom.codeContainer).removeClass('is-hidden is-active');
    }
  }
};

var hasCartGifts = function hasCartGifts(cart) {
  // Free gifts based on items in window variable - window.bva.giftProducts
  return cart.items.some(function (item) {
    return Object.keys(window.bva.giftProducts).includes(item.product_id.toString());
  });
};

var removeCouponCode = function () {
  var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
    var skipCartAction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var freeGiftVariantId;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _jsCookie2.default.remove('bva-cart-coupon-code');
            _jsCookie2.default.remove('bva-cart-coupon-code-data');
            _jsCookie2.default.remove('bva-cart-coupon-code-options');
            window.chCouponCode = '';
            freeGiftVariantId = window.bva.cart.items.reduce(function (id, item) {
              if (Object.keys(window.bva.giftProducts).includes(item.product_id.toString())) {
                id = item.id;
              }
              return id;
            }, 0);

            if (!freeGiftVariantId) {
              _context2.next = 11;
              break;
            }

            if (skipCartAction) {
              _context2.next = 10;
              break;
            }

            _context2.next = 9;
            return (0, _AddToCart.cartRemove)(freeGiftVariantId).then(_Cart.updateCartUI).catch(console.error);

          case 9:
            return _context2.abrupt('return', _context2.sent);

          case 10:
            return _context2.abrupt('return', (0, _defineProperty3.default)({}, freeGiftVariantId, 0));

          case 11:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));

  return function removeCouponCode() {
    return _ref5.apply(this, arguments);
  };
}();

var toggleCodeForm = function toggleCodeForm(event) {
  // // If form is open &
  if ($(dom.bodyWithOpenCodeForm).length) {
    // Clicked inside the form, skip
    if ($(dom.codeForm).has(event.target).length) {
      return;
    }
    // Clicked the remove code button
    else if (event.target.matches(dom.codeRemove)) {
        return $(dom.body).toggleClass('code-form-open');
      }
  }

  event.preventDefault();

  $(dom.codeForm).toggleClass('is-active');
  $(dom.codeContainer).toggleClass('is-active');
  if ($(dom.codeForm).hasClass('is-active')) {
    var inlineCart = $('[data-inline-cart] [cart-main]');
    inlineCart.animate({
      scrollTop: inlineCart.find(dom.codeForm).position().top
    }, 300);
  }
  // Css update is only to fix safari input cursor bug
  if (!$(dom.bodyWithOpenCodeForm).length) {
    $(dom.codeInput).trigger('focus').css('opacity', 0.95);
  }
  setTimeout(function () {
    $(dom.codeInput).css('opacity', 1);
    $(dom.body).toggleClass('code-form-open');
  }, 300);
};

var submitCodeForm = function () {
  var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(event) {
    var $form, code, foundTSGift;
    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            event.preventDefault();
            $form = $(event.currentTarget);
            code = $(dom.codeInput, $form).val();
            _context3.next = 5;
            return applyGift(code, $form);

          case 5:
            foundTSGift = _context3.sent;

            $(dom.codeSubmit, $form).addClass('is-loading');
            submitDiscountForm(code, $form, !foundTSGift);

          case 8:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, undefined);
  }));

  return function submitCodeForm(_x4) {
    return _ref7.apply(this, arguments);
  };
}();

var getTieredDiscountIndex = function getTieredDiscountIndex(codeName) {
  return Object.keys(TIERS).indexOf(codeName.toUpperCase());
};

var getHighestActiveTierIndex = function getHighestActiveTierIndex() {
  return Object.values(TIERS).reduce(function (highestIndex, tierPrice, index) {
    if (window.bva.cart.total_price >= tierPrice) highestIndex = index;
    return highestIndex;
  }, 0);
};

var updateDiscountUI = exports.updateDiscountUI = function () {
  var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(totalPrice) {
    var code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var codeName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var discount, foundTSGift, codeLowerCase, _ref9, _ref9$cs, cs, currentTierIndex, isTieredDiscount, highestActiveTierIndex, newTierCode, isValid, isFreeGift, entitledProductIds, hasEntitledProduct, displayTotal, cookiedCode, codeTitle, layout, _code, options, error, skipCartAction;

    return _regenerator2.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            discount = void 0;
            foundTSGift = false;

            if (!codeName) {
              _context4.next = 18;
              break;
            }

            codeLowerCase = codeName.toString().toLowerCase();
            _ref9 = window.n || {}, _ref9$cs = _ref9.cs, cs = _ref9$cs === undefined ? {} : _ref9$cs;

            foundTSGift = cs[codeLowerCase] || false;

            // Tiers setup - This discount has expired
            // Logic preserved for potential use in the future
            // Check for any of the tiered discount codes
            // Switch to highest tier threshold that is currently satisfied
            // Reset current discount, apply new one (if tier changes)
            // Return and break out
            currentTierIndex = getTieredDiscountIndex(codeName);
            isTieredDiscount = currentTierIndex !== -1;

            if (!isTieredDiscount) {
              _context4.next = 18;
              break;
            }

            // Get achieved tier
            highestActiveTierIndex = getHighestActiveTierIndex();

            // Update active discount code

            if (!(highestActiveTierIndex !== currentTierIndex)) {
              _context4.next = 18;
              break;
            }

            newTierCode = Object.keys(TIERS)[highestActiveTierIndex];
            // Remove current code

            _jsCookie2.default.remove('bva-cart-coupon-code');
            _jsCookie2.default.remove('bva-cart-coupon-code-data');
            _jsCookie2.default.remove('bva-cart-coupon-code-options');
            // Set new code
            _jsCookie2.default.set('bva-cart-coupon-code', newTierCode, { expires: 2 });
            _jsCookie2.default.set('bva-cart-coupon-code-options', JSON.stringify({ skip_errors: true }), { expires: 2 });
            return _context4.abrupt('return', initDiscountFromCookie());

          case 18:
            if (!code) {
              _context4.next = 28;
              break;
            }

            _context4.next = 21;
            return validateDiscountConditions(code, $(dom.codeForm), !foundTSGift);

          case 21:
            _context4.t0 = _context4.sent;

            if (_context4.t0) {
              _context4.next = 24;
              break;
            }

            _context4.t0 = false;

          case 24:
            isValid = _context4.t0;

            if (isValid) {
              isFreeGift = code.entitled_product_ids ? code.entitled_product_ids.find(function (id) {
                return Object.keys(window.bva.giftProducts).includes(id.toString());
              }) : false;

              if (!isFreeGift) {
                // If no specific entitled products, include all cart products
                entitledProductIds = code.entitled_product_ids.length ? code.entitled_product_ids : window.bva.cart.items.map(function (item) {
                  return item.product_id;
                });
                // Calculate discount only for entitled & non-excluded products

                if (code.value_type == 'percentage') {
                  discount = window.bva.cart.items.reduce(function (amount, item) {
                    var isEntitledProduct = entitledProductIds.includes(item.product_id) && !code.excluded_products_ids.includes(item.product_id);
                    if (isEntitledProduct) amount += item.line_price * (parseFloat(code.value) / 100);
                    return amount;
                  }, 0);
                } else if (code.value_type == 'fixed_amount') {
                  hasEntitledProduct = window.bva.cart.items.some(function (item) {
                    return entitledProductIds.includes(item.product_id) && !code.excluded_products_ids.includes(item.product_id);
                  });

                  if (hasEntitledProduct) discount = parseInt(code.value, 10) * 100;
                }
              }

              displayTotal = '' + (0, _Helpers.formatMoney)(totalPrice);

              if (isFreeGift) discount = 'Free Gift';else {
                displayTotal = '' + (0, _Helpers.formatMoney)(totalPrice - Math.abs(discount));
                discount = '-' + (0, _Helpers.formatMoney)(Math.abs(discount));
              }

              // This is a fix for the bulk discount code app creating codes with different/lengthy titles
              cookiedCode = _jsCookie2.default.get('bva-cart-coupon-code') || false;
              codeTitle = cookiedCode ? cookiedCode : code.title;
              layout = '\n        <div class="cart-header__price-row price-row__coupon" cart-code-totals><span class="row-label">Coupon: ' + codeTitle + '</span><span class="row-value u-text-right">' + discount + ' <button class="price-row__remove btn--blank" cart-code-remove>[Remove]</button></span></div>\n        <hr cart-code-totals>\n        <div class="cart-header__price-row price-row__total" cart-code-totals><span class="row-label">Total</span><span class="row-value u-text-right">' + displayTotal + '</span></div>\n      ';

              $(dom.cartFullInfo).html(layout);
              $('[data-inline-cart]').addClass('has-discount');
            } else {
              _code = _jsCookie2.default.get('bva-cart-coupon-code') || false;
              options = _jsCookie2.default.getJSON('bva-cart-coupon-code-options') || { skip_errors: false };

              if (_code && !options.skip_errors) {
                error = getErrorMessage(_code, false);

                if (error && window.bva.cart.item_count > 0) $(dom.cartFullInfo).html(error);else $('[data-inline-cart]').removeClass('has-discount');
              } else if (window.bva.cart.item_count < 1) $('[data-inline-cart]').removeClass('has-discount');
            }
            _context4.next = 32;
            break;

          case 28:
            $(dom.codeForm).removeClass('is-active');

            if (codeName) {
              _context4.next = 32;
              break;
            }

            skipCartAction = true;
            return _context4.abrupt('return', resetDiscount(skipCartAction));

          case 32:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, undefined);
  }));

  return function updateDiscountUI(_x5) {
    return _ref8.apply(this, arguments);
  };
}();

var getErrorMessage = function getErrorMessage(code) {
  var skipCartCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var error = '';

  // Set defaults

  var _ref10 = code || {},
      _ref10$shopify = _ref10.shopify,
      shopify = _ref10$shopify === undefined ? {} : _ref10$shopify,
      _ref10$recharge = _ref10.recharge,
      recharge = _ref10$recharge === undefined ? false : _ref10$recharge,
      _ref10$excluded_produ = _ref10.excluded_products_ids,
      excluded_products_ids = _ref10$excluded_produ === undefined ? [] : _ref10$excluded_produ,
      _ref10$entitled_produ = _ref10.entitled_product_ids,
      entitled_product_ids = _ref10$entitled_produ === undefined ? [] : _ref10$entitled_produ,
      _ref10$prerequisite_s = _ref10.prerequisite_subtotal_range,
      prerequisite_subtotal_range = _ref10$prerequisite_s === undefined ? false : _ref10$prerequisite_s,
      _ref10$usage_limit = _ref10.usage_limit,
      usage_limit = _ref10$usage_limit === undefined ? false : _ref10$usage_limit,
      _ref10$usage_count = _ref10.usage_count,
      usage_count = _ref10$usage_count === undefined ? 0 : _ref10$usage_count,
      _ref10$starts_at = _ref10.starts_at,
      starts_at = _ref10$starts_at === undefined ? false : _ref10$starts_at,
      _ref10$ends_at = _ref10.ends_at,
      ends_at = _ref10$ends_at === undefined ? false : _ref10$ends_at;

  if (shopify && shopify.status === 'error') return 'Code entered is not valid.';

  // Incorrect purchase type - Shopify only - Exit
  if (recharge && !recharge.length && (0, _Cart.isSubscriptionCart)()) {
    return 'This discount is unavailable for any subscription products in your cart. Please remove subscription products to use this discount.';
  }

  // Cart contains only excluded items (i.e. gift cards)
  if (excluded_products_ids.length) {
    var cartFilledWithExcludedProducts = window.bva.cart.items.every(function (item) {
      return excluded_products_ids.includes(item.product_id);
    });
    if (cartFilledWithExcludedProducts) return 'The discount is unavailable for the products found in your cart.';
  }

  // Cart price is too low
  if (prerequisite_subtotal_range) {
    if (window.bva.cart.original_total_price < parseFloat(prerequisite_subtotal_range.greater_than_or_equal_to) * 100) {
      var entitledItemsText = entitled_product_ids.length ? ' for entitled items' : '';
      error += 'A minimum price of $' + parseInt(prerequisite_subtotal_range.greater_than_or_equal_to).toFixed(2) + entitledItemsText + ' is required for this discount to be valid. ';
    }
  }
  // Cart does not contain neccessary products
  if (entitled_product_ids.length && !skipCartCheck) {
    var cartHasEntitledProduct = window.bva.cart.items.some(function (item) {
      return entitled_product_ids.indexOf(item.product_id) !== -1;
    });
    if (!cartHasEntitledProduct) error += 'The discount requires a product that was not found in your cart. ';
  }

  // Over usage limit
  if (usage_limit && usage_count >= usage_limit) error += "The discount has reached it's usage limit. ";

  // Invalid date
  if (starts_at && new Date(starts_at) > Date.now() || ends_at && Date.now() > new Date(ends_at)) error += 'The discount is unavailable at this date. ';

  return error;
};

var validateDiscountConditions = function () {
  var _ref11 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(code, $form) {
    var skipCartCheck = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var error;
    return _regenerator2.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            error = getErrorMessage(code, skipCartCheck);

            if (!error) {
              _context5.next = 4;
              break;
            }

            codeSubmitInvalid(error);
            return _context5.abrupt('return', false);

          case 4:
            return _context5.abrupt('return', true);

          case 5:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, undefined);
  }));

  return function validateDiscountConditions(_x9, _x10) {
    return _ref11.apply(this, arguments);
  };
}();

var applyGift = function applyGift(code, $form) {
  if (window.bva.cart.item_count > 0) {
    var codeLowerCase = code.toLowerCase();

    var _ref12 = window.n || {},
        _ref12$cs = _ref12.cs,
        cs = _ref12$cs === undefined ? {} : _ref12$cs;

    var id = cs[codeLowerCase] || false;
    if (id) {
      window.chCouponCode = code;
      _jsCookie2.default.set('bva-cart-coupon-code', code, { expires: 2 });
      $(dom.codeSubmit).removeClass('is-loading').addClass('is-success');
      return (0, _AddToCart.cartUpdate)((0, _defineProperty3.default)({}, id, 1)).then(codeSubmitSuccess).catch(codeSubmitError);
    }
  }
  return false;
};

var submitDiscountForm = function () {
  var _ref13 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(code, $form) {
    var addToCart = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return _regenerator2.default.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            $.get('https://bvanative-js.herokuapp.com/discount/' + code).done(function () {
              var _ref14 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(data) {
                var freeGiftProductId, skipCartCheck, isValid, id, options, _isValid;

                return _regenerator2.default.wrap(function _callee6$(_context6) {
                  while (1) {
                    switch (_context6.prev = _context6.next) {
                      case 0:
                        if (!(Object.keys(data).length && window.bva.cart.item_count > 0)) {
                          _context6.next = 24;
                          break;
                        }

                        freeGiftProductId = data.entitled_product_ids ? data.entitled_product_ids.find(function (id) {
                          return Object.keys(window.bva.giftProducts).includes(id.toString());
                        }) : false;

                        if (!freeGiftProductId) {
                          _context6.next = 17;
                          break;
                        }

                        // Add free gift
                        skipCartCheck = true;
                        _context6.next = 6;
                        return validateDiscountConditions(data, $form, skipCartCheck);

                      case 6:
                        isValid = _context6.sent;

                        if (!isValid) {
                          _context6.next = 15;
                          break;
                        }

                        _jsCookie2.default.set('bva-cart-coupon-code', code, { expires: 2 });
                        _jsCookie2.default.set('bva-cart-coupon-code-data', JSON.stringify(data), { expires: 2 });

                        if (!addToCart) {
                          _context6.next = 15;
                          break;
                        }

                        window.chCouponCode = code;
                        id = window.bva.giftProducts[freeGiftProductId][0];
                        _context6.next = 15;
                        return (0, _AddToCart.cartUpdate)((0, _defineProperty3.default)({}, id, 1)).then(codeSubmitSuccess).catch(codeSubmitError);

                      case 15:
                        _context6.next = 22;
                        break;

                      case 17:
                        options = _jsCookie2.default.getJSON('bva-cart-coupon-code-options') || { skip_errors: false };
                        _context6.next = 20;
                        return validateDiscountConditions(data, $form);

                      case 20:
                        _isValid = _context6.sent;

                        if (_isValid || options.skip_errors) {
                          _jsCookie2.default.set('bva-cart-coupon-code', code, { expires: 2 });
                          _jsCookie2.default.set('bva-cart-coupon-code-data', JSON.stringify(data), { expires: 2 });
                          window.chCouponCode = code;
                          codeSubmitSuccess(window.bva.cart, $form);
                          (0, _AddToCart.updateCart)(window.bva.cart);
                        }

                      case 22:
                        _context6.next = 25;
                        break;

                      case 24:
                        if (addToCart) {
                          codeSubmitInvalid(null);
                        }

                      case 25:
                      case 'end':
                        return _context6.stop();
                    }
                  }
                }, _callee6, undefined);
              }));

              return function (_x15) {
                return _ref14.apply(this, arguments);
              };
            }()).fail(function (err) {
              codeSubmitInvalid(null);
            });

          case 1:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, undefined);
  }));

  return function submitDiscountForm(_x12, _x13) {
    return _ref13.apply(this, arguments);
  };
}();

var resetDiscountUI = exports.resetDiscountUI = function resetDiscountUI() {
  $(dom.cartExtraTotals).remove();
  $(dom.codeForm).removeClass('is-active');
  $(dom.codeContainer).removeClass('is-hidden is-active');
  $('[data-inline-cart]').removeClass('has-discount');
};

var resetDiscount = exports.resetDiscount = function () {
  var _ref15 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8() {
    var skipCartAction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var update;
    return _regenerator2.default.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return removeCouponCode(skipCartAction);

          case 2:
            update = _context8.sent;

            resetDiscountUI();
            return _context8.abrupt('return', update);

          case 5:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, undefined);
  }));

  return function resetDiscount() {
    return _ref15.apply(this, arguments);
  };
}();

// Updated to use the vanilla dropdown event, not jquery 'change' event
var updateGiftItem = function updateGiftItem(event) {
  var giftSelect = $(dom.giftSelect).get(0);
  if (event.detail.container.contains(giftSelect)) {
    var _cartUpdate3;

    var $this = $(giftSelect);
    var $lineItem = $this.closest(dom.lineItem);
    var $dropdown = $this.closest(dom.dropdownContainer);
    var oldVariantId = $this.attr('data-variant-id');
    var newVariantId = $dropdown.find(dom.dropdownValue).filter('.is-active').attr('data-variant-id');
    updateGiftMeta($lineItem);

    (0, _AddToCart.cartUpdate)((_cartUpdate3 = {}, (0, _defineProperty3.default)(_cartUpdate3, oldVariantId, 0), (0, _defineProperty3.default)(_cartUpdate3, newVariantId, 1), _cartUpdate3));

    // update mobile select
    var value = $this.val();
    $(dom.giftSelectNative).val(value);
    $(dom.giftSelectNative).find('option').removeProp('selected').filter('[value="' + value + '"]').prop('selected', true);
  }
};

var bindUIActions = function bindUIActions() {
  $(dom.codeToggle).on('click', toggleCodeForm);

  // Close code form when clicking outside
  $(document).on('click', dom.bodyWithOpenCodeForm, toggleCodeForm);

  $(dom.codeForm).on('submit', submitCodeForm);

  // Re-created this with vanilla so that the event would bubble to global scope
  // Triggered within components/Dropdown, compiled into theme.js
  // jQuery seems to be instanced per JS bundle, rather than global
  // $(document).on('change', dom.giftSelect, updateGiftItem);
  document.addEventListener('dropdown.updated', updateGiftItem);

  $(document).on('change', dom.giftSelectNative, function (event) {
    var $this = $(event.target);
    var value = $this.val();
    var $matchingItem = $(dom.giftSelectItem).filter('[data-dropdown-value="' + value + '"]');
    $matchingItem.trigger('click');
  });

  $(document).on('click', dom.codeRemove, function () {
    return resetDiscount();
  });

  document.addEventListener('cart.ui.updated', initDiscountFromCookie);
};

var captureTalkable = exports.captureTalkable = function captureTalkable() {
  if (window.location.search.indexOf('utm_source=talkable') === -1) {
    return;
  }

  var code = (0, _Helpers.getUrlParameterByName)('cid', window.location.search);

  if (!code) {
    return;
  }

  _jsCookie2.default.set('bva-cart-coupon-code', code, { expires: 2 });
};

var initDiscountFromCookie = function initDiscountFromCookie() {
  var code = _jsCookie2.default.get('bva-cart-coupon-code') || false;
  var codeData = _jsCookie2.default.getJSON('bva-cart-coupon-code-data') || false;
  if (code) {
    if (!codeData) {
      var $giftLineItem = $(dom.lineItem).filter('.is-free-gift');
      if (!$giftLineItem.length) {
        $(dom.codeInput).val(code);
        $(dom.codeForm).trigger('submit');
      }
    }
  }
};

var initAutoDiscountCode = exports.initAutoDiscountCode = function initAutoDiscountCode() {
  var discountParam = (0, _Helpers.getUrlParameterByName)('discount');
  if (discountParam) {
    // Set discount cookie and trigger form submit
    resetDiscount();
    _jsCookie2.default.set('bva-cart-coupon-code', discountParam, { expires: 2 });
    _jsCookie2.default.set('bva-cart-coupon-code-options', JSON.stringify({ skip_errors: true }), { expires: 2 });
    initDiscountFromCookie();
    // Update url to remove discount code
    var discountUrlString = 'discount=' + discountParam;
    var params = window.location.search;
    params = params.replace('&' + discountUrlString, '').replace(discountUrlString, '').replace('?&', '?');
    if (params === '?') params = '';
    var url = window.location.pathname + params;
    window.history.replaceState({}, null, url);
  }
};

// Keep to re-engague this issue at a later time - currently buggy
// export const updateCartTokenCache = () => {
//   const token = window.bva.cart.token || false;
//   Cookies.set('bva-cached-cart-token', token, { expires: 2 });
// };

// Keep to re-engague this issue at a later time - currently buggy
// Will disable any previously added discounts if the users cart token has changed/expired
// export const cartTokenCompareAndUpdateDiscount = () => {
//   const token = window.bva.cart.token || false;
//   const cachedToken = Cookies.get('bva-cached-cart-token') || false;
//   if (token !== cachedToken) removeCouponCode();
//   updateCartTokenCache();
// };

var init = exports.init = function init() {
  bindUIActions();
};